import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { SIZING as PAGE_SIZING } from '~/views/components/pageWrapper/styles';

type WithIsExpanded = { $isExpanded: boolean };

const SCOREBOARD_TOP = BaseStyle.LEAGUE_HEADER_HEIGHT - 1;

export const ScoreboardContainer = styled.div<
    WithIsExpanded & { $isSeries?: boolean; $isWebview?: boolean; $isSticky?: boolean }
>`
    align-items: center;
    background: ${({ theme }) => theme.Surface.primary};
    border-radius: ${({ $isExpanded }) => ($isExpanded ? '0' : '4px')};
    display: flex;
    height: 96px;
    justify-content: space-around;
    margin-bottom: 24px;
    position: ${({ $isSticky }) => ($isSticky ? 'sticky' : 'initial')};
    top: ${({ $isWebview }) => ($isWebview ? 0 : SCOREBOARD_TOP + 'px')};
    width: 100%;
    z-index: 2;
    padding: ${({ $isSeries }) => ($isSeries ? '22px 16px' : 0)};
    border: ${({ $isExpanded, theme }) => ($isExpanded ? 'initial' : `solid 1px ${theme.Surface.border}`)};
    border-bottom: solid 1px ${({ theme }) => theme.Surface.border};

    ${BaseStyle.Mixins.screenSizes.medium} {
        box-shadow: initial;
        justify-content: space-between;
        padding: 0;
    }

    ${({ $isExpanded, $isSeries, theme }) =>
        $isExpanded &&
        css`
            ${BaseStyle.Mixins.utility.boxShadow(8, theme.Surface.shim, [BaseStyle.StyleDirections.down])};
            margin-left: ${-PAGE_SIZING.smallHorizontal}px;
            width: 100vw;

            /**
             * This calculation takes the full screen size and subtracts the main content area so we get just the size
             * of the sides (Gray area) We then divide that in half so we get the size of only one side. Finally we
             * subtract the page padding to move this to the correct location
            */
            ${BaseStyle.Mixins.screenSizes.large} {
                margin-left: min(
                    -${$isSeries ? PAGE_SIZING.largeHorizontal : PAGE_SIZING.smallHorizontal}px,
                    calc((100vw - ${PAGE_SIZING.maxWidth}px) / -2 - ${PAGE_SIZING.largeHorizontal}px)
                );
            }

            ${BaseStyle.Mixins.screenSizes.extraLarge} {
                margin-left: min(
                    -${PAGE_SIZING.largeHorizontal}px,
                    calc((100vw - ${PAGE_SIZING.maxWidth}px) / -2 - ${PAGE_SIZING.largeHorizontal}px)
                );
            }
        `}
`;

// taken from this example: https://stackoverflow.com/questions/68490380/how-to-rename-a-table-header-element-with-aria
export const HiddenDiv = styled.h1`
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    height: 1px;
    width: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
`;
